import { isNumber } from 'lodash';
import React, { FC, useRef, useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { educationDataStore } from 'src/store/educationFee';
import { getMemberInfo } from 'src/utils/common';
import {
  errorModalViewStore,
  loadingModalViewStore,
  confirmModalViewStore,
  contentModalDep2ViewStore,
} from 'src/store/modal';
import { fetchInsertEducationData, fetchUpdateEducationData } from 'src/fetch/stepC/education';
import DefLabel from 'src/components/atoms/label/LabelContnet';
import InputBox from 'src/components/atoms/input/DefInputBox';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import LabelSelect from 'src/components/atoms/selectbox/LabelSelect';
import CheckBox from 'src/components/atoms/CheckBox';
import HelpButton from 'src/components/atoms/buttons/HelpButton';
import Description from 'src/components/molecules/table/Description/Education';
import {
  settlementNtsDataStore,
  ntsFileDataStore,
  settlementDataStore,
} from 'src/store/settlementInfo';
import { addComma } from 'src/utils/common';

interface Props {
  data: any;
  type: any;
}
const GridAdd: FC<Props> = ({ data, type }) => {
  const userInfoData: any = getMemberInfo();

  const queryClient = useQueryClient();
  const errorModalState = errorModalViewStore((state: any) => state.set);
  const loadingState = loadingModalViewStore((state: any) => state.set);
  const setConfirmModalState = confirmModalViewStore((state: any) => state.set);
  const closeModalState = confirmModalViewStore((state: any) => state.close);
  const setContentModalState = contentModalDep2ViewStore((state: any) => state.set);

  const storeData = educationDataStore((state: any) => state.result).data || [];
  const storeInitPayload = educationDataStore((state: any) => state.initPayload);
  const storePayload = educationDataStore((state: any) => state.payload);
  const storePayloadBind = educationDataStore((state: any) => state.bindPayload);
  const bindStoreParam = educationDataStore((state: any) => state.param);
  const bindStoreBindParam = educationDataStore((state: any) => state.bindParam);

  // 정산결과
  const settlementBindParam = settlementDataStore((state: any) => state.bindParam);
  const settlementParam = settlementDataStore((state: any) => state.param);
  // 정산결과(NTS)
  const ntsInfoBindParam = settlementNtsDataStore((state: any) => state.bindParam);
  const ntsInfoParam = settlementNtsDataStore((state: any) => state.param);
  // NTS 업로드파일 데이터
  const ntsFileBindParam = ntsFileDataStore((state: any) => state.bindParam);
  const ntsFileParam = ntsFileDataStore((state: any) => state.param);

  useEffect(() => {
    if (type === 'insert') {
      storePayloadBind({ ...storeInitPayload });
    } else {
      const storeData = data.infoData;
      for (const key in storePayload) {
        if (storeData) storePayload[key] = storeData[key];
      }
      storePayloadBind({ ...storePayload, name: data.name });
    }
  }, [storeData]);

  const familyDataSet = storeData;
  const familySet = familyDataSet.map((item: any) => {
    return { id: item.family_seqid, value: item.name };
  });
  familySet.unshift({ id: '', value: '선택' });
  const checkedFamily =
    storePayload.family_seqid === 0
      ? familySet[0]
      : { id: storePayload.family_seqid, value: storePayload.name };

  const familySelect = {
    checked: checkedFamily,
    options: familySet,
  };

  const dataTypeSet = [
    { id: '', value: '선택' },
    {
      id: '1',
      value: '본인(대학원등..)',
    },
    {
      id: '2',
      value: '취학전아동',
    },
    {
      id: '3',
      value: '초,중,고등학교 / 중,고생 교복비 / 초·중·고 체험학습비',
    },
    {
      id: '4',
      value: '대학교(대학원 불포함)',
    },
    {
      id: '5',
      value: '장애인 특수교육비',
    },
  ];
  const checkedDataType =
    storePayload.data_type === ''
      ? dataTypeSet[0]
      : {
          id: storePayload.data_type,
          value: dataTypeSet.find((item: any) => item.id === storePayload.data_type)?.value,
        };

  const dataTypeSelect: any = {
    checked: checkedDataType,
    options: dataTypeSet,
  };
  const viewData = data || [];

  const help = {
    content: `
      <div className="_hint_content">
        <div className="_item">① 수업료ㆍ입학금ㆍ보육비용ㆍ수강료 및 그 밖의 공납금(육성회비, 기성회비 등)</div>
        <div className="_item">② 초ㆍ중ㆍ고등학교의 학생을 위한 다음의 교육비</div>
        <div className="_item _pa10">㉠ 「학교급식법」에 따라 학교급식을 실시하는 학교에 지급한 급식비</div>
        <div className="_item _pa10">㉡ 학교에서 구입한 교과서대금</div>
        <div className="_item _pa10 _h_col1">㉢ 「초ㆍ중등교육법」에 따른 학교에서 실시하는 방과후학교 수업료(도서구입비 포함)(제출서류: 방과후 학교 수업용 도서 구입 증명서)</div>
        <div className="_item">③ 중ㆍ고등학교의 학생의 교복(체육복 포함)구입비용(학생 1명당 연 50만원을 한도로 함)</div>
        <div className="_item">④ 국외교육비 : 국외에 소재하는 교육기관으로서 우리나라의 유아교육법에 의한 유치원, 초중등교육법 또는 고등교육법에 의한 학교(대학 등)에 해당하는 기관에 지출한 교육비에 한하여 공제</div>
        <div className="_item _pa10">㉠ 국외근무자 : 근로자 본인과 국외에서 동거하는 기본공제대상자(나이 요건 X)</div>
        <div className="_item _pa10">㉡ 국내근무자 :</div>
        <div className="_item _pa10">&nbsp;&nbsp;- 고등학생, 대학생</div>
        <div className="_item _pa10">&nbsp;&nbsp;- 초등학교 취학전 아동, 초등학생, 중학생 (요건 : 국외유학에관한규정 제5조에 의해 자비유학자격이 있는 학생 or 국외유학에관한 규정</div>
        <div className="_item _pa10">&nbsp;&nbsp;제15조에 의해 유학을 하는 자로서 부양의무자와 국외에서 동거한 기간이 1년 이상인 학생)</div>
        <div className="_item _pa10">㉢ 제출서류 : 교육비 납입을 증명할 수 있는 서류, 재학증명서, 부양가족의 유학자격 입증 서류(근로자가 국내 근무하는 경우)</div>
        <div className="_item _h_col1">⑤ 초·중·고 체험학습비 : 학교에서 실시하는 수련활동, 수학여행 등 현장체험학습비 지출액 (한도:학생1인당 연30만원)</div>
        <div className="_item _h_col1">⑥ 본인을 위해 지급한 학자금대출 원리금 상환액</div>
        <div className="_item _h1">※ 소득세 또는 증여세가 비과세되는 수업료 등(사내근로복지기금으로부터 받은 장학금 등)은 공제불가</div>
      </div>
      `,
    title: '공제 대상 항목',
  };

  const help_t2 = {
    content: `
      <div className="_hint_content">
        <div className="_item">* 사업자 등록번호(주민등록번호)는 '-'를 제외한 숫자만 입력해야 합니다.</div>
      </div>
      `,
    title: '사업자등록번호',
  };

  const confirmSelect = (item: any, field: string) => {
    if (field === 'family_seqid') {
      storePayloadBind({ ...storeInitPayload, family_seqid: item.id, name: item.value });
    } else {
      storePayload[field] = item.id;
      storePayloadBind({ ...storePayload });
    }
  };

  const confirmEvt = () => {
    storePayload.acct_year = userInfoData.acct_year;
    storePayload.co_cd = userInfoData.co_cd;
    storePayload.co_id = userInfoData.co_id;
    const param: any = storePayload;
    fetchInsertEducationData(param, queryClient, errorModalState, loadingState, () => {
      const initialSeq = bindStoreParam.initialSeq || 0;
      bindStoreBindParam({ initialSeq: initialSeq + 1 });

      const initialSetSeq = settlementParam.initialSeq || 0;
      settlementBindParam({ initialSeq: initialSetSeq + 1 });
      const initialNtsSeq = ntsInfoParam.initialSeq || 0;
      ntsInfoBindParam({ initialSeq: initialNtsSeq + 1 });
      const initialFileSeq = ntsFileParam.initialSeq || 0;
      ntsFileBindParam({ initialSeq: initialFileSeq + 1 });

      setContentModalState({
        active: '',
      });
    });
  };

  // UPDATE
  const modifyEvt = () => {
    storePayload.acct_year = userInfoData.acct_year;
    storePayload.co_cd = userInfoData.co_cd;
    storePayload.co_id = userInfoData.co_id;
    const param: any = storePayload;

    // return false;
    fetchUpdateEducationData(param, queryClient, errorModalState, loadingState, () => {
      const initialSeq = bindStoreParam.initialSeq || 0;
      bindStoreBindParam({ initialSeq: initialSeq + 1 });

      const initialSetSeq = settlementParam.initialSeq || 0;
      settlementBindParam({ initialSeq: initialSetSeq + 1 });
      const initialNtsSeq = ntsInfoParam.initialSeq || 0;
      ntsInfoBindParam({ initialSeq: initialNtsSeq + 1 });
      const initialFileSeq = ntsFileParam.initialSeq || 0;
      ntsFileBindParam({ initialSeq: initialFileSeq + 1 });

      setContentModalState({
        active: '',
      });
    });
  };

  const inpStrChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    const chkValue = e.target?.value || '';
    storePayload[key] = chkValue;
    storePayloadBind({ ...storePayload });
  };
  const inpChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    let chkValue = e.target?.value || '';
    chkValue = chkValue.replaceAll(',', '');
    const chkNum = Number(chkValue);
    if (chkNum || chkNum === 0) {
      storePayload[key] = chkNum;
      storePayloadBind({ ...storePayload });
    }
  };

  return (
    <div className="_add_credit_layout">
      {/* <div className="_desc_div">
        <div className="_main">총 급여의 25% : 10,000,000</div>
        <div className="_sub">신용카드등은 총급여의 25% 이상이어야 공제 가능합니다.</div>
      </div> */}
      <div className="_title_div">
        <div className="_title">공제 대상 항목</div>
        <div className="_help_div">
          <HelpButton content={help.content} title={help.title} styleDef={{ width: '800px' }} />
        </div>
      </div>
      <div className="_inp_div">
        <div className="_opt_div">
          <div className="_item" style={{ zIndex: 20, width: '450px' }}>
            {/* <div className="_item" style={{ zIndex: 20 }}>
            <LabelSelect
              label="성명"
              select={familySelect}
              labelStyle={{ width: '120px' }}
              boxStyleDef={{ width: 'calc(100% - 120px)' }}
              confirmEvent={confirmSelect}
              field="family_seqid"
            />
          </div> */}
            {type === 'insert' ? (
              <LabelSelect
                label="성명"
                select={familySelect}
                labelStyle={{ width: '200px' }}
                boxStyleDef={{ width: 'calc(100% - 200px)' }}
                confirmEvent={confirmSelect}
                field="family_seqid"
              />
            ) : (
              <div className="_title_div">
                <DefLabel
                  label="성명"
                  content={storePayload.name || ''}
                  styleDef={{ color: '#333', fontWeight: '600', fontSize: '15px' }}
                  labelStyleDef={{
                    fontWeight: '500',
                    fontSize: '14px',
                    // width: '80px',
                    paddingRight: '100px',
                  }}
                />
              </div>
            )}
          </div>
          <div className="_item" style={{ zIndex: 15, width: '450px' }}>
            <LabelSelect
              label="교육비 구분"
              select={dataTypeSelect}
              labelStyle={{ width: '200px' }}
              boxStyleDef={{ width: 'calc(100% - 200px)' }}
              confirmEvent={confirmSelect}
              field="data_type"
            />
          </div>
          <div className="_item" style={{ zIndex: 5, width: '450px' }}>
            <InputBox
              changeEvt={e => inpChangeEvt(e, 'htx_amt')}
              label="지출금액(국세청)"
              status={''}
              labelPosition="left"
              value={addComma(storePayload.htx_amt)}
              placeholder="값을 입력하세요"
              labelStyleDef={{ width: '200px', color: '#333', fontSize: '14px' }}
              // styleDef={boxStyle}
              inpStyleDef={{ textAlign: 'right' }}
            />
          </div>
          <div className="_item" style={{ zIndex: 5, width: '450px' }}>
            <InputBox
              changeEvt={e => inpChangeEvt(e, 'amt')}
              // inputRef={inpRef}
              label="지출금액(기타)"
              status={''}
              labelPosition="left"
              value={addComma(storePayload.amt)}
              placeholder="값을 입력하세요"
              labelStyleDef={{ width: '200px', color: '#333', fontSize: '14px' }}
              // styleDef={boxStyle}
              inpStyleDef={{ textAlign: 'right' }}
            />
          </div>
          <div className="_item" style={{ zIndex: 5, width: '450px' }}>
            <InputBox
              changeEvt={e => inpChangeEvt(e, 'htx_expt_amt')}
              // inputRef={inpRef}
              label="PDF제외금액"
              status={''}
              labelPosition="left"
              value={addComma(storePayload.htx_expt_amt)}
              placeholder="값을 입력하세요"
              labelStyleDef={{ width: '200px', color: '#333', fontSize: '14px' }}
              // styleDef={boxStyle}
              inpStyleDef={{ textAlign: 'right' }}
            />
          </div>
          {/* <div className="_item _chk">
            <CheckBox
              label="해외교육비"
              selected={inpState.hometaxYN.value ? 'on' : 'off'}
              btnClickEvt={checkClickEvt}
              labelStyleDef={{ color: '#333', fontWeight: '500', width: '130px' }}
            />
          </div> */}
        </div>
      </div>
      <div className="_description">
        <Description />
      </div>
      <div className="_btn_div">
        {type === 'insert' ? (
          <DefaultButton
            text="내역 추가"
            styleDef={{ width: '250px' }}
            clickEvent={e => confirmEvt()}
            icon=""
            type="type5"
          />
        ) : (
          <DefaultButton
            text="내역 변경"
            styleDef={{ width: '250px' }}
            clickEvent={e => modifyEvt()}
            icon=""
            type="type3"
          />
        )}
      </div>
    </div>
  );
};

export default GridAdd;
